/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DeviceConfigurationItemDto
 */
export interface DeviceConfigurationItemDto {
    /**
     *
     * @type {Date}
     * @memberof DeviceConfigurationItemDto
     */
    createdAt?: Date;
    /**
     *
     * @type {Date}
     * @memberof DeviceConfigurationItemDto
     */
    updatedAt?: Date;
    /**
     *
     * @type {number}
     * @memberof DeviceConfigurationItemDto
     */
    deviceConfigurationIndexId?: number;
    /**
     *
     * @type {string}
     * @memberof DeviceConfigurationItemDto
     */
    key?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceConfigurationItemDto
     */
    status?: DeviceConfigurationItemDtoStatusEnum;
    /**
     *
     * @type {string}
     * @memberof DeviceConfigurationItemDto
     */
    valueLastApplied?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceConfigurationItemDto
     */
    valueInProgress?: string;
    /**
     * If true, this key cannot be changed by illuminate
     * @type {boolean}
     * @memberof DeviceConfigurationItemDto
     */
    isReadOnly?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof DeviceConfigurationItemDto
     */
    isPersistent?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof DeviceConfigurationItemDto
     */
    isConstant?: boolean;
}

/**
 * @export
 */
export const DeviceConfigurationItemDtoStatusEnum = {
    Applying: "Applying",
    Applied: "Applied",
    IlluminateOnly: "IlluminateOnly",
} as const;
export type DeviceConfigurationItemDtoStatusEnum =
    (typeof DeviceConfigurationItemDtoStatusEnum)[keyof typeof DeviceConfigurationItemDtoStatusEnum];

/**
 * Check if a given object implements the DeviceConfigurationItemDto interface.
 */
export function instanceOfDeviceConfigurationItemDto(
    value: object,
): value is DeviceConfigurationItemDto {
    return true;
}

export function DeviceConfigurationItemDtoFromJSON(
    json: any,
): DeviceConfigurationItemDto {
    return DeviceConfigurationItemDtoFromJSONTyped(json, false);
}

export function DeviceConfigurationItemDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceConfigurationItemDto {
    if (json == null) {
        return json;
    }
    return {
        createdAt:
            json["createdAt"] == null ? undefined : new Date(json["createdAt"]),
        updatedAt:
            json["updatedAt"] == null ? undefined : new Date(json["updatedAt"]),
        deviceConfigurationIndexId:
            json["deviceConfigurationIndexId"] == null
                ? undefined
                : json["deviceConfigurationIndexId"],
        key: json["key"] == null ? undefined : json["key"],
        status: json["status"] == null ? undefined : json["status"],
        valueLastApplied:
            json["valueLastApplied"] == null
                ? undefined
                : json["valueLastApplied"],
        valueInProgress:
            json["valueInProgress"] == null
                ? undefined
                : json["valueInProgress"],
        isReadOnly: json["isReadOnly"] == null ? undefined : json["isReadOnly"],
        isPersistent:
            json["isPersistent"] == null ? undefined : json["isPersistent"],
        isConstant: json["isConstant"] == null ? undefined : json["isConstant"],
    };
}

export function DeviceConfigurationItemDtoToJSON(
    value?: DeviceConfigurationItemDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        createdAt:
            value["createdAt"] == null
                ? undefined
                : value["createdAt"].toISOString(),
        updatedAt:
            value["updatedAt"] == null
                ? undefined
                : value["updatedAt"].toISOString(),
        deviceConfigurationIndexId: value["deviceConfigurationIndexId"],
        key: value["key"],
        status: value["status"],
        valueLastApplied: value["valueLastApplied"],
        valueInProgress: value["valueInProgress"],
        isReadOnly: value["isReadOnly"],
        isPersistent: value["isPersistent"],
        isConstant: value["isConstant"],
    };
}
